// eslint-disable-next-line import/prefer-default-export
export const isNonEmptyArray = (val) => {
  return Array.isArray(val) && val.length > 0;
};
